// extracted by mini-css-extract-plugin
export default {"wrapper":"cq-z","response":"dq-z","error":"eq-z","disabled":"fq-z","buttons":"gq-z","feedbackQuestionSection":"hq-z","yesNoWrapper":"iq-z"};